import React, { useMemo } from "react";

import { useScrollVisible } from "@common/util/useScrollVisible";
import { URI } from "../../types";
import { Loading } from "./Loading";
import { PreviewImage } from "./PreviewImage";

type Props = Readonly<{
  active: boolean;
  index: number;
  onFocus: (index: number) => void;
  onImageLoaded: (image: HTMLImageElement) => void;
  scrollParent: HTMLElement;
  src: URI;
  total: number;
  visible: boolean;
}>;

export const PreviewImageLoader = ({
  active,
  index,
  onFocus,
  onImageLoaded,
  scrollParent,
  src,
  total,
  visible,
}: Props) => {
  const [, setObserverRef, isVisible] = useScrollVisible(scrollParent, "0px");
  const previewClassName = useMemo(() => {
    const classes = ["image-preview"];
    if (visible) {
      classes.push("visible");
      if (active) {
        classes.push("active");
      }
    }
    return classes.join(" ");
  }, [active, visible]);
  let contents = null;
  if (isVisible) {
    contents = <PreviewImage onImageLoaded={onImageLoaded} src={src} />;
  } else {
    contents = <Loading />;
  }
  return (
    <div
      onClick={() => {
        onFocus(index);
      }}
      ref={setObserverRef}
    >
      <div className={previewClassName}>
        {contents}
        <span>{`Page ${index + 1} of ${total}`}</span>
      </div>
    </div>
  );
};
PreviewImageLoader.displayName = "PreviewImageLoader";
